module.exports = __webpack_public_path__ + "img/grid-blue.8ead4023.svg";